import React, { useState, useEffect } from 'react';

/* UI Library Components */
import { Drawer, Button } from 'antd';

/* Icons */
import { FilterOutlined } from '@ant-design/icons';

/* Components */
import FilterMenu from './FilterMenu';

/* Utilities */
// import { useHistory } from 'react-router-dom'; // ❌ Se comenta: dejó de usarse en react-router-dom v6
import { useNavigate, useLocation } from 'react-router-dom'; // ✅ Corrección: ahora se usa useNavigate y useLocation

const FilterDrawer = ({ core }) => {
  const navigate = useNavigate(); // ✅ Ahora se usa navigate
  const location = useLocation(); // ✅ Para acceder al pathname y search
  const [visible, setVisible] = useState(false);
  const [tutorial, setTutorial] = useState(true);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const onClick = () => {
    // ✅ Actualizado: se usa location en vez de history.location
    const URL = new URLSearchParams(location.search);
    let filteredURL = `${location.pathname}?`;

    filteredURL += URL.has('data') ? `data=${URL.get('data')}` : '';
    filteredURL += URL.has('id') ? `id=${URL.get('id')}` : '';
    filteredURL += URL.has('keywords') ? `&keywords=${URL.get('keywords')}` : '';

    core.setURL(filteredURL);
    navigate(filteredURL); // ✅ Reemplaza history.push por navigate
    onClose();
  };

  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
        setTutorial(false);
      }, 4000);
    }, 2000);
  }, []);

  return (
    <>
      <Button
        size="large"
        icon={<FilterOutlined />}
        onClick={showDrawer}
        className="fixed-widget"
        type="primary"
      >
        Filtros
      </Button>
      <Drawer
        title="Filtros"
        placement={'left'}
        style={{ zIndex: 1002 }}
        onClose={onClose}
        open={visible} // ✅ Cambio: 'visible' ahora es 'open' en nuevas versiones de antd (>v4.23)
        bodyStyle={{ padding: 0 }}
        footer={
          <Button size="large" onClick={onClick}>
            Limpiar Filtros
          </Button>
        }
        footerStyle={{ textAlign: 'right' }}
      >
        <FilterMenu core={core} onClose={onClose} />
        {tutorial && (
          <div id="filter__drawer--tutorial">
            <p>
              En este panel encontrarás los filtros disponibles según la
              información que estés consultando.
            </p>
          </div>
        )}
      </Drawer>
    </>
  );
};

export default FilterDrawer;
